// @todo A SUPPRIMER QUAND SUPPRESION dev_chat_expand_zone

import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import stopPropagation from '@mailobj-browser/front/js/events/hooks/stopPropagation.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import once from '@mailobj-browser/front/js/events/options/once.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import keyDown from '@mailobj-browser/front/js/events/types/keyDown.js'
import load from '@mailobj-browser/front/js/events/types/load.js'
import submit from '@mailobj-browser/front/js/events/types/submit.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import globals from '#utilities/js/ea/globals.js'
import { elements } from './../../../styles.js'

const onLoad = object(listener, {
  type: load,
  passive,
  once,
  task: (
    rte
  ) => {
    const htmlDocument = rte.closest('html')
    const form = rte.closest('form')
    const lang = htmlDocument.getAttribute('lang')
    const dir = htmlDocument.getAttribute('dir')
    const html = `<!DOCTYPE html><html lang="${lang}" dir="${dir}"><head><meta charset="utf-8"><style>body {font-family: Arial,serif;font-size:13px}</style><title>-</title></head><body><br /></body></html>`
    const { contentDocument } = rte

    contentDocument.designMode = 'on'
    contentDocument.write(html)
    contentDocument.close()

    onKeyDown.listen(contentDocument)
    onSubmitForm.listen(form)
  }
})

const onKeyDown = object(listener, {
  type: keyDown,
  task: (
    contentDocument,
    event
  ) => {
    const { keyCode } = event

    if (keyCode === 13) {
      preventDefault(event)

      const { defaultView } = contentDocument
      const { top } = defaultView
      const { document } = top
      const form = one(`.${elements.rte_submit}`, document).closest('form')

      onSubmitForm.task(form, event)
    }
  }
})

const onSubmitForm = object(listener, {
  type: submit,
  hooks: array([
    preventDefault,
    stopPropagation
  ]),
  task: (
    form
  ) => {
    const rte = one('[data-rte="chat"]', form)
    const button = one(`.${elements.rte_submit}`)
    const { contentDocument } = rte
    const { body } = contentDocument

    queueMicrotask(async () => {
      await send(button, rte, form)
      rte.focus() //FOR FF
      body.focus()
    })
  }
})

const send = (button, rte, form) => {
  const { contentDocument } = rte
  const { body } = contentDocument
  const inputHiddenHdn = one('[name="chat_msg"]', form)
  const defaultValue = '<br />'
  const { dataset } = button
  const { target } = dataset

  button.setAttribute('disabled', '')

  if (body.innerHTML !== defaultValue) {
    inputHiddenHdn.value = body.innerHTML
    // A modifier quand gestion des sessions sera ok côté bundle
    globals.ea_form(button, target, null)

    inputHiddenHdn.value = defaultValue
    body.innerHTML = defaultValue
  }

  button.removeAttribute('disabled')
}

export default rte => {
  const { contentWindow } = rte

  if (contentWindow) {
    return onLoad.task(rte)
  }

  onLoad.listen(rte)
}
